module.exports = "https://coursera_assets.s3.amazonaws.com/images/69d8d47404e3da1d706b895876d3b49e.png";